"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getNumUnitString = function (num, input) {
    num = parseInt(num);
    input = parseInt(input);
    return input === 365 && num === 1
        ? 'Year'
        : input === 365 && num != 1
            ? 'Years'
            : input === 30 && num == 1
                ? 'Month'
                : input == 30 && num != 1
                    ? 'Months'
                    : input === 7 && num == 1
                        ? 'Week'
                        : input === 7 && num != 1
                            ? 'Weeks'
                            : input === 1 && num == 1
                                ? 'Day'
                                : input === 1 && num != 1
                                    ? 'Days'
                                    : '';
};
exports.default = getNumUnitString;
